
import { getCurrencyText } from '@share/utils';

import './style.scss';

interface IProps {
  currency: string | null | undefined;
}

export function Currency(props: IProps) {
  const { currency } = props;

  return <>{getCurrencyText(currency)}</>;
}
